import { Flex, FormControl, FormErrorMessage, FormLabel, Input, Select } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import COUNTRIES from "@/constants/countries.json";
import { CityType, CountryType, DoctorOverview, StateType } from "@/types";

interface AddressInformationProps {
  register: any;
  errors: any;
  setValue: any;
  editingUser?: DoctorOverview | null;
}

const AddressInformation: React.FC<AddressInformationProps> = ({ register, errors, setValue, editingUser = null }) => {
  const [states, setStates] = useState<StateType[] | null>();
  const [cities, setCities] = useState<CityType[] | null>();

  useEffect(() => {
    if (editingUser && editingUser.addresses?.primary) {
      const primaryAddress = editingUser.addresses.primary;
      
      setValue('address.address1', primaryAddress.street || '');
      setValue('address.address2', editingUser.addresses?.secondary.street || '');
      setValue('address.pincode', primaryAddress.pincode);

      const selectedCountry = (COUNTRIES as CountryType[]).find(
        (country) => country.name === primaryAddress.country
      );
      
      if (selectedCountry) {
        setStates(selectedCountry.states);

        const selectedState = selectedCountry.states.find(
          (state) => state.name === primaryAddress.state
        );
        
        if (selectedState) {
          setCities(selectedState.cities);
        }
      }
    }
  }, [editingUser, setValue]);

  useEffect(() => {
    if (editingUser && editingUser.addresses?.primary) {
      const primaryAddress = editingUser.addresses.primary;
      
      setValue('address.country', primaryAddress.country);
      
      if (states && states.length > 0) {
        setValue('address.state', primaryAddress.state);
      }
      
      if (cities && cities.length > 0) {
        setValue('address.city', primaryAddress.city);
      }
    }
  }, [editingUser, setValue, states, cities]);

  return (
    <>
      <Flex justify="space-between" align="flex-start" gap={2} mt={2}>
        <FormControl isInvalid={!!errors.address?.address1}>
          <FormLabel fontWeight="medium">Address 1</FormLabel>
          <Input {...register("address.address1")} placeholder="e.g. 123 Main Street" />
          <FormErrorMessage minH="20px">{errors.address?.address1?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.address?.address2}>
          <FormLabel fontWeight="medium">Address 2</FormLabel>
          <Input {...register("address.address2")} placeholder="e.g. Apt 4B" />
          <FormErrorMessage minH="20px">{errors.address?.address2?.message}</FormErrorMessage>
        </FormControl>
      </Flex>
      <Flex justify="space-between" align="flex-start" gap={2} mt={2}>
        <FormControl isInvalid={!!errors.address?.country}>
          <FormLabel fontWeight="medium">Country</FormLabel>
          <Select
            {...register("address.country")}
            onChange={(e) => {
              const selectedCountry = (COUNTRIES as CountryType[]).find((country) => country.name === e.target.value);
              if (selectedCountry) {
                console.log(selectedCountry);
                setStates(selectedCountry.states);
              } else {
                setStates([]);
              }
              setCities([]);
            }}
          >
            <option value={''}>
              Select
            </option>
            {(COUNTRIES as CountryType[]).map((country: CountryType) => {
              return (
                <option key={country.name} value={country.name}>
                  {country.name}
                </option>
              );
            })}
          </Select>
          <FormErrorMessage minH="20px">{errors.address?.country?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.address?.state}>
          <FormLabel fontWeight="medium">State/Province</FormLabel>
          <Select {...register("address.state")} onChange={(e) => {
              const selectedState = states?.find((state) => state.name === e.target.value);
              if (selectedState) {
                setCities(selectedState.cities);
              } else {
                setCities([]);
              }
            }}>
            <option value={''}>
              Select
            </option>
            {states && states.map((state) => <option key={state.name} value={state.name}>{state.name}</option>)}
          </Select>
          <FormErrorMessage minH="20px">{errors.address?.state?.message}</FormErrorMessage>
        </FormControl>
      </Flex>
      <Flex justify="space-between" align="flex-start" gap={2} mt={2}>
        <FormControl isInvalid={!!errors.address?.city}>
          <FormLabel fontWeight="medium">City</FormLabel>
          <Select {...register("address.city")}>
            <option value={''}>
              Select
            </option>
            {cities && cities.map((city) => <option key={city.name} value={city.name}>{city.name}</option>)}
          </Select>
          <FormErrorMessage minH="20px">{errors.address?.city?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.address?.pincode}>
          <FormLabel fontWeight="medium">Pincode</FormLabel>
          <Input {...register("address.pincode")} placeholder="e.g. 1100" />
          <FormErrorMessage minH="20px">{errors.address?.pincode?.message}</FormErrorMessage>
        </FormControl>
      </Flex>
    </>
  );
};

export default AddressInformation;